import { render, staticRenderFns } from "./DragVerify.vue?vue&type=template&id=32d01ff3&scoped=true&"
import script from "./DragVerify.vue?vue&type=script&lang=ts&"
export * from "./DragVerify.vue?vue&type=script&lang=ts&"
import style0 from "./DragVerify.vue?vue&type=style&index=0&id=32d01ff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d01ff3",
  null
  
)

export default component.exports